<section class="view">
  <section class="view-section">
    <div class="view-section__header">
      <div>
        <p class="view-section__eyebrow">Resumo do produto</p>
        <h3 class="view-section__title">{{ productName || 'Produto selecionado' }}</h3>
      </div>
    </div>

    <div class="view-grid view-grid--summary">
      <article class="view-field-card">
        <span class="view-field-card__label">Banco</span>
        <strong class="view-field-card__value">{{ bankName }}</strong>
      </article>

      <article class="view-field-card">
        <span class="view-field-card__label">Empresa</span>
        <strong class="view-field-card__value">{{ companyName }}</strong>
      </article>

      <article class="view-field-card">
        <span class="view-field-card__label">Período</span>
        <strong class="view-field-card__value">{{ product.Period }}</strong>
      </article>

      <article class="view-field-card">
        <span class="view-field-card__label">Tipo de comissão</span>
        <strong class="view-field-card__value">{{ commissionTypeName }}</strong>
      </article>

      <article class="view-field-card">
        <span class="view-field-card__label">Máx. de comissão por contrato</span>
        <strong class="view-field-card__value">{{ product.MaxCommissionPerContract | currency: "BRL" }}</strong>
      </article>
    </div>
  </section>

  <section class="view-section" *ngIf="isFixedCommissionType">
    <div class="view-section__header">
      <div>
        <p class="view-section__eyebrow">Valores fixos</p>
        <h3 class="view-section__title">Composição da comissão</h3>
      </div>
    </div>

    <div class="view-grid view-grid--fixed">
      <article class="view-value-card" *ngFor="let production of product.Productions; let index = index">
        <div class="view-value-card__header">
          <span class="view-value-card__badge">Faixa {{ index + 1 }}</span>
        </div>

        <div class="view-value-card__body">
          <div class="view-value-card__metric">
            <span class="view-value-card__label">Valor fixo Credimorar</span>
            <strong class="view-value-card__amount">{{ production.InvoiceValue | currency: "BRL" }}</strong>
          </div>

          <div class="view-value-card__metric">
            <span class="view-value-card__label">Valor fixo beneficiários</span>
            <strong class="view-value-card__amount">{{ production.TransferValue | currency: "BRL" }}</strong>
          </div>
        </div>
      </article>
    </div>
  </section>

  <section class="view-section" *ngIf="!isFixedCommissionType">
    <div class="view-section__header">
      <div>
        <p class="view-section__eyebrow">Faixas variáveis</p>
        <h3 class="view-section__title">Regras por produção</h3>
      </div>
    </div>

    <div class="view-grid view-grid--production">
      <article *ngFor="let production of product.Productions; let index = index" class="view-production-card">
        <div class="view-production-card__header">
          <span class="view-production-card__badge">Faixa {{ index + 1 }}</span>
        </div>

        <div class="view-production-card__grid">
          <div class="view-production-card__field">
            <span class="view-production-card__label">Produção inicial</span>
            <strong class="view-production-card__value">{{ production.InitialProduction | currency: "BRL" }}</strong>
          </div>

          <div class="view-production-card__field">
            <span class="view-production-card__label">Produção final</span>
            <strong class="view-production-card__value">{{ production.FinalProduction | currency: "BRL" }}</strong>
          </div>

          <div class="view-production-card__field">
            <span class="view-production-card__label">Percentual</span>
            <strong class="view-production-card__value">{{ production.Percentage }}%</strong>
          </div>
        </div>
      </article>
    </div>
  </section>
</section>
